import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import WCButton from "@/components/WCButton";
import AnimateIn from "@/components/AnimateIn";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const redirect = loc.state?.from || "/account";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back.");
      navigate(redirect);
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="bg-black min-h-screen pt-[160px] md:pt-[200px] pb-24 px-6" data-testid="login-page">
      <div className="max-w-md mx-auto">
        <AnimateIn variant="fade">
          <h1 className="wc-heading text-white text-5xl md:text-6xl tracking-widest text-center">
            LOG IN
          </h1>
          <p className="text-white/60 text-center mt-4 text-sm">
            Welcome back to WrongConception.
          </p>
        </AnimateIn>

        <form onSubmit={submit} className="mt-12 space-y-5" data-testid="login-form">
          <Field label="EMAIL" type="email" value={email} onChange={setEmail} testid="login-email" />
          <Field
            label="PASSWORD"
            type="password"
            value={password}
            onChange={setPassword}
            testid="login-password"
          />
          <WCButton type="submit" filled disabled={loading} className="w-full" data-testid="login-submit">
            {loading ? "SIGNING IN..." : "SIGN IN"}
          </WCButton>
        </form>

        <div className="flex items-center gap-4 my-8">
          <div className="flex-1 h-px bg-white/20" />
          <span className="wc-label text-xs text-white/40">OR</span>
          <div className="flex-1 h-px bg-white/20" />
        </div>

        <button
          onClick={loginWithGoogle}
          className="wc-btn w-full flex items-center justify-center gap-3"
          data-testid="login-google"
        >
          <GoogleIcon />
          <span>Continue with Google</span>
        </button>

        <p className="text-center text-white/60 text-sm mt-10">
          New to WrongConception?{" "}
          <Link to="/register" className="text-white underline" data-testid="login-to-register">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}

const Field = ({ label, testid, onChange, ...rest }) => (
  <div>
    <label className="wc-label text-xs text-white block mb-2">{label}</label>
    <input
      {...rest}
      onChange={(e) => onChange(e.target.value)}
      required
      data-testid={testid}
      className="w-full bg-transparent border border-white/40 focus:border-white text-white outline-none px-5 py-4 text-base transition-colors"
    />
  </div>
);

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#fff" d="M44.5 20H24v8.5h11.8C34.9 33.1 30.1 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.9 3l6-6C34.6 5.5 29.6 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21c10.5 0 20-7.6 20-21 0-1.3-.2-2.6-.5-4z" />
  </svg>
);
